export default __webpack_public_path__ + "static/media/plus_icon_disabled.179987e4.svg";